<div id="{{ ids }}"
     data-parallax="true"
     [style.background]="'url(' + bgImage + ')'"
     class="{{ classNames }} ">
  <ng-content></ng-content>
</div>
